import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { ISelectOptionProps } from 'components/form/types';
import { useModal } from 'store/modal';
import CreateEntity from 'components/crud/CreateEntity';
import ClientForm from '../../components/ClientForm';
import { IInputs } from '../../components/types';

interface IProps {
  typeOptions: ISelectOptionProps[];
  langOptions: ISelectOptionProps[];
}

const CreateForm: FC<IProps> = ({ typeOptions, langOptions }: IProps) => {
  const { showModal } = useModal();
  const methods = useForm<IInputs>();

  return (
    <CreateEntity
      entity="clients"
      methods={methods}
      onSuccess={(res: any) => {
        const { id } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              Създадохте клиент <span className="font-weight-bold">{id}</span>.
            </>
          ),
        });
      }}
      queryKey="clients"
      onSuccessPushToLink="/clients"
    >
      {(create: any) => (
        <ClientForm
          methods={methods}
          handleSubmit={data => {
            const formatData = {
              ...data,
              type: data.type.value,
              default_lang: data.default_lang.value,
              absence_webhook_url: data.absence_webhook_url?.trim() || null,
              // TODO - check why pass representatives fields separately, possible to skip
              second_representative_names: data.second_representative_names ?? null,
              second_representative_egn: data.second_representative_egn ?? null,
              second_representative_position: data.second_representative_position ?? null,
              third_representative_names: data.third_representative_names ?? null,
              third_representative_egn: data.third_representative_egn ?? null,
              third_representative_position: data.third_representative_position ?? null,
            };

            // Add leave_review and exit_interview to client_features and as key of the data
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const { client_features, leave_review, exit_interview, ...rest } = formatData;
            const updatedFeatures = { ...client_features, leave_review, exit_interview };
            const formatDataForCreate = { ...rest, leave_review, exit_interview, client_features: updatedFeatures };

            return create(formatDataForCreate);
          }}
          btnLabel="Запази"
          typeOptions={typeOptions}
          langOptions={langOptions}
        />
      )}
    </CreateEntity>
  );
};

export default CreateForm;
